<template>
  <section id="template-kits-filters">
    <b-row>
      <b-col cols="4" class="pl-0">
        <label>
          Template de kit
        </label>
        <b-form-input
          id="kit"
          type="text"
          v-model="filters.query"
          placeholder="Buscar por template de kit"
          debounce="1000"
        />
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label for="local_stock_sector_id">Setor</label>
          <multiselect
              id="local_stock_sector_id"
              autocomplete="off"
              v-model="selectedStockLocation"
              :options="stockLocationOptions"
              track-by="id"
              label="label"
              :option-height="40"
              :showLabels="false"
              :searchable="true"
              placeholder="Selecionar"
              class="with-border"
              ref="local_stock_sector_id"
              @select="el => ( filters.local_stock_sector_id = el.id )"
          >
            <template slot="caret">
              <div class="chevron">
                <ChevronDown />
              </div>
            </template>
            <template slot="noOptions"> Nenhuma opção </template>
            <template slot="noResult"> Nenhum resultado </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <label>
          Produto incluso no template
        </label>
        <Autocomplete
          v-model="filters.product"
          :options="productOptions"
          placeholder="Digite para pesquisar"
          @update="searchProduct($event)"
          debounce="1000" 
        />
      </b-col>
      <b-col cols="2" class="mt-1">
        <PeriodSelect
          label="Período"
          @select="handlePeriod"
          top="35px"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {
  name: 'kit-filters',
  components: {
    Autocomplete: () => import('@/components/Autocomplete.vue'),
    PeriodSelect: () => import('@/components/General/Periods.vue'),
    ChevronDown: () => import('@/assets/icons/chevron-down.svg'),
  },
  data () {
    return {
      clinic: JSON.parse(localStorage.getItem('clinic')),
      productOptions: [],
      originOptions: [],
      selectedStockLocation: null,
      stockLocationOptions: [],
      filters: {
        query: null,
        product: null,
        origin: null,
        start_date: null,
        end_date: null,
        local_stock_sector_id: null
      }
    }
  },
  mounted() {
    this.getWarehouseLocationSectors();
  }, 
  methods: {
    handlePeriod(value) {
      this.filters.start_date = value.start
      this.filters.end_date = value.end
    },
    async searchOrigin (query) {
      if (!query?.length) return;

      try {
        const res = await this.api.getKitOrigins(this.clinic.id, query) 
        this.originOptions = res.data.map(origin => ({
          value: origin?.id,
          label: origin?.name,
        }))

      } catch (error) {
        this.$toast.error('Não foi possível encontrar a origem, contato o suporte se o erro persistir.')
      }
    },
    async searchProduct (query) {
      if (!query?.length) return;

      try {
        const res = await this.api.searchProducts(this.clinic.id, query) 
        this.productOptions = res.data.map(product => ({
          value: product?.id,
          barcode: product?.barcode,
          label: `${product?.number} - ${product?.name}`,
        }))
      } catch (error) {
        this.$toast.error('Não foi possível encontrar o produto, contato o suporte se o erro persistir.')
      }
    },
    getWarehouseLocationSectors(query) {
      this.stockLocationOptions = [];
      
      this.api.getWarehouseLocations(this.clinic.id, {})
        .then(res => {
          res.data
          .forEach(location => {
            location.sectors.map(sector => {
              this.stockLocationOptions.push({
                label: `${location?.name} - ${sector?.name}`,
                id: sector.id
              });
            });
          });
        })
        .catch(err => this.$toast.error(err.message))
      },
  },
  watch: {
    filters: {
      handler: function (val) {
        this.$emit('update', val)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
#template-kits-filters {
  padding: 0px 10px;

  label {
    color: var(--dark-blue);
    font-weight: 700;
  }
}
</style>